module.exports = __webpack_public_path__ + "media/images/default-8b817a9bc1484a73fe94881244fda314.png";